export default "__VITE_ASSET__Rz_GRj4K_66I5njNJSR1iQ__"